import React from "react";
import { TextMessage as TextMessageType } from "../../../types/chat";
import FormattedText from "../FormattedText";
import styles from "./TextMessage.module.scss";

interface TextMessageProps {
  message: TextMessageType;
  isOwnMessage?: boolean;
}

/**
 * Component hiển thị tin nhắn văn bản
 */
const TextMessage: React.FC<TextMessageProps> = ({ message, isOwnMessage = false }) => {
  return (
    <div className={styles.textMessage}>
      {/* Message Content with Mentions and Clickable URLs */}
      <div className={styles.messageText}>
        <FormattedText text={message.content.message} />
      </div>
    </div>
  );
};

export default TextMessage;
